<template>
  <div class="layout-wrapper">
    <router-view />
    <!-- 登录弹窗 -->
    <LoginModal :open="open" />
    <div class="back-index" @click="banckIndex" v-show="route.name != 'Index'">
      <div class="icon"></div>
      <div class="text">首页</div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import store from "@/store";
// import useWeChatSdk from "@/hooks/useWeChatSdk";

import LoginModal from "./LoginModal.vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const open = computed(() => store.getters["user/getH5LoginPop"]);
onMounted(() => {
  // useWeChatSdk(
  //   "2024脑健康大会",
  //   "2024脑健康大会 7月21日 中国 北京",
  //   location.href,
  //   "https://ntppc.oss-cn-shanghai.aliyuncs.com/mp4/20240719a7omop5q.png"
  // );
});

const banckIndex = () => {
  router.push({ name: "Index" });
};
</script>

<style scoped lang="less">
.layout-wrapper {
  height: 100%;
  .back-index {
    width: 74px;
    height: 32px;
    background: @theme-color;
    border-radius: 100px 0px 0px 100px;
    position: fixed;
    bottom: 126px;
    right: 0;
    display: flex;
    align-items: start;
    justify-content: center;
    z-index: 9;
    transition: 0.5s;
    .icon {
      background: url("../../assets/h5/icon-home.png") no-repeat 0 0;
      background-size: 100% 100%;
      width: 17px;
      height: 15px;
      margin-right: 5px;
      margin-top: 8px;
    }
    .text {
      margin-top: 7px;
      font-size: 12px;
      font-weight: 500;
      color: #ffffff;
      line-height: 18px;
      height: 17px;
    }
  }
}
</style>
